import { atom } from "jotai";

export const bookingQrUrl = atom('');
export const deliveryQrUrl = atom('');
export const timerAtom = atom(0);
